export enum ListLogSourceSortFieldsEnum {
  dateCreated = 'dateCreated',
  health = 'health',
}
